import PropTypes from 'prop-types';
import React from 'react';
import styles from './EmptyCard.scss';
import classnames from 'classnames';

const Title = ({ children }) =>
  <div className={styles.emptyCardTitle}>
    {children}
  </div>;
const Message = ({ children }) =>
  <div className={styles.emptyCardMessage}>
    {children}
  </div>;

export default function EmptyCard(props) {
  const { children, title, message, modal } = props;
  const className = classnames(styles.emptyCard, {
    [styles.emptyCardModal]: modal === true,
    [styles.emptyCardInline]: modal !== true,
  });

  return (
    <div className={className}>
      <div className="overflow-hidden">
        {children
          ? children
          : <div>
              {title &&
                <Title>
                  {title}
                </Title>}
              {message &&
                <Message>
                  {message}
                </Message>}
            </div>}
      </div>
    </div>
  );
}

EmptyCard.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  modal: PropTypes.bool,
};

EmptyCard.Title = Title;
EmptyCard.Message = Message;
EmptyCard.Unauthorized = props =>
  <EmptyCard
    title="Unauthorized"
    message="You do not have access to this resource."
    {...props}
  />;
EmptyCard.PageNotFound = props =>
  <EmptyCard
    title="Page Not Found"
    message="This page might have moved."
    {...props}
  />;



// WEBPACK FOOTER //
// ./src/components/Common/EmptyCard.js